/**
 * 关爱通工具类
 */

import { localget } from './storage';
import consts from 'Utils/consts';
import api from 'Plugins/api';
import { Toast } from 'vant';


/**
 * 是否是关爱通
 * @return {boolean}
 */
export function isGat() {
  const channelParam = localget(consts.thirdChannelParam);
  return channelParam && 'gat' === channelParam.accessChannel;
}

/**
 * 关爱通支付
 * @param orderId 订单id
 * @param orderType 订单类型
 */
export function toPayForGat(orderId, orderType) {
  Toast.loading({message: '支付中...', loadingType: 'spinner', forbidClick: true, duration: 0});
  api['common/gatPay']({orderId, orderType}).then(res => {
    const { cashierAddress } = res.data || {};
    if (cashierAddress) {
      window.location.href = cashierAddress;
    } else {
      Toast.fail({message: '支付失败', duration: 3000});
    }
  }).catch(ignore => {// 接口异常无需处理程序会自动处理
  }).finally(() => {
    Toast.clear();
  });
}
